(() => {
  if (window.VzyDigital17Adapter) return;

  const SELECTORS = Object.freeze({
    benefitsWrapper: '.custom-liquid',
    price: '.price-wrapper',
    installment: '.installment-wrapper',
    packageComponent: '.vzy-qb',
    packageWrapper: '.custom-liquid',
    promoComponent: 'vzy-promo-dispatch',
    promoWrapper: '.custom-liquid',
    actions: '.product__buy-buttons',
    klarnaPlacement: 'klarna-placement',
    klarnaWrapper: '.shopify-app-block',
    variantPicker: 'variant-selects, variant-radios'
  });

  window.VzyDigital17Adapter = Object.freeze({
    version: '1.7',
    resolvePurchase(root, host) {
      const packages = root?.querySelector(SELECTORS.packageComponent) || null;
      const klarnaPlacement = root?.querySelector(SELECTORS.klarnaPlacement) || null;
      return {
        benefitsWrapper: host?.closest(SELECTORS.benefitsWrapper) || null,
        price: root?.querySelector(SELECTORS.price) || null,
        installment: root?.querySelector(SELECTORS.installment) || null,
        packages,
        packageWrapper: packages?.closest(SELECTORS.packageWrapper) || null,
        promoWrapper: (root?.querySelector(SELECTORS.promoComponent) || null)?.closest(SELECTORS.promoWrapper) || null,
        actions: root?.querySelector(SELECTORS.actions) || null,
        klarnaPlacement,
        klarnaWrapper: klarnaPlacement?.closest(SELECTORS.klarnaWrapper) || null
      };
    },
    currentVariant(root, variantId) {
      const picker = root?.querySelector(SELECTORS.variantPicker) || null;
      const variant = picker?.currentVariant;
      return variant && String(variant.id) === String(variantId) ? variant : null;
    }
  });
})();
